import React from 'react';

import WsIconProps from './IconProps';

const Dice: React.FC<WsIconProps> = ({
  color = 'white',
  color2 = '#888A8E',
  width = 16,
  height = 17,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10453_48302)">
      <path
        d="M14.2596 12.4137C14.1665 13.1442 13.4989 13.6609 12.7684 13.5678L10.5 13.2786L11.6189 4.49957L13.8873 4.78868C14.6178 4.88178 15.1345 5.54942 15.0414 6.27989L14.2596 12.4137Z"
        fill={color}
        stroke={color2}
        strokeWidth="1.33333"
      />
      <path
        d="M1.90342 12.3318C2.00881 13.0606 2.68505 13.5659 3.41385 13.4606L5.39756 13.1737L4.14335 4.50009L2.15964 4.78694C1.43084 4.89233 0.92546 5.56857 1.03085 6.29737L1.90342 12.3318Z"
        fill={color}
        stroke={color2}
        strokeWidth="1.33333"
      />
      <rect
        x="12"
        y="14.5"
        width="8.66667"
        height="12"
        rx="1.33333"
        transform="rotate(-180 12 14.5)"
        fill="white"
        stroke={color2}
        strokeWidth="1.33333"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.73348 6.36635V6.89967H6C5.63181 6.89967 5.33333 7.19815 5.33333 7.56634V9.96634C5.33333 10.3345 5.63181 10.633 6 10.633H9.33333C9.70152 10.633 10 10.3345 10 9.96634V7.56634C10 7.19815 9.70152 6.89967 9.33333 6.89967H8.60001V6.36635H8.60015V5.83301H8.60001H8.13334H7.20015H6.73348V6.36635ZM8.13334 6.36635H7.20015V6.89967H8.13334V6.36635Z"
        fill={color2}
      />
    </g>
    <defs>
      <clipPath id="clip0_10453_48302">
        <rect width={width} height={height} fill={color} transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default Dice;
